module.exports = __webpack_public_path__ + "img/public/SiteIcons/plus.svg?402ab4b0";